import AIChatbotSection from "@components/AIChatbotSection";
import AiChatbotSections from "@components/AiChatbotSections";
import AiCompareComponent from "@components/AiCompareComponent";
import AiHeroSection from "@components/AiHeroSection";
import ImageGrid from "@components/ImageGrid";
import CardDataCarousal from "@components/LandingPageComponents/CardDataCarousal";
import { CardDataDetailsProps } from "@components/LandingPageComponents/CardDataDetails";
import FeatureCardSection from "@components/LandingPageComponents/CardSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import YellowCTAhref from "@components/yellowCTAhref";
import icon1 from "public/ai1.png";
import icon2 from "public/ai2.png";
import icon3 from "public/ai3.png";
import React from "react";

const cardDataCollection: CardDataDetailsProps[] = [
    {
        img: "https://assets.gallabox.com/gb-home/ai/icon1.png",
        title: "Say Goodbye to Your Writer's Block",
        description:
            "Generate Text is an AI-powered writing assistant at your disposal, whether your team needs help creating context-specific messages or articulating responses to customer queries.",
    },
    {
        img: "https://assets.gallabox.com/gb-home/ai/icon2.png",
        title: "Talk to Your Customers in Their Language",
        description:
            "Don’t sweat over Google Translate when a customer texts in a different language. Our nifty 'Translate' feature lets you chat like a local and read responses in your preferred language.",
    },

    {
        img: "https://assets.gallabox.com/gb-home/ai/icon3.png",
        title: "Shorten or Fluff Up Content On-Demand",
        description:
            "Equip your team to shorten messages, or perhaps fluff 'em up a bit as the conversation demands with our AI rewrite feature which gives professional editors a run for their money.",
    },
    {
        img: "https://assets.gallabox.com/gb-home/ai/icon4.png",
        title: "Keep Your Replies Simple and Sleek",
        description:
            "Help your team cut down the technical jargon and break down complex messages into understandable, easily digestible yet professional replies that enhance customer experience.",
    },
];
const sections = [
    {
        title: "Personalized Travel Plans",
        icon: icon1,
        title2: "Personalized Travel Plans",
        desc: "Make vacation planning easy for your customers with Gallabox's AI bot that finds affordable accommodations within budget and lists them by price, location, or any other parameter.",
        img: "https://assets.gallabox.com/gb-home/ai/section1-updated.png",
    },
    {
        title: "Tailored Ed-Tech Experiences",
        icon: icon2,
        title2: "Tailored Ed-Tech Experiences",
        desc: "Answers student questions with our AI-powered chatbot which combs through pre-defined FAQs to gather information, collate them, analyze, and send customized responses.",
        img: "https://assets.gallabox.com/gb-home/ai/section2.png",
    },
    {
        title: "Streamlined Shopping",
        icon: icon3,
        title2: "Streamlined Shopping",
        desc: "Improves shopping using advanced filters and knowledge base analysis. If a customer asks for 'cheap red sneakers,' the bot filters products by price and colour, showing all affordable red sneakers. This makes shopping efficient and personalized.",
        img: "https://assets.gallabox.com/gb-home/ai/section3-updated.png",
    },
];

const aiCompareData = {
    others: [
        "Expensive Price Tag",
        "Linear and predictable text flow",
        "Limited capacity to understand the context",
        "Prone to outages and overloads",
        "Based on pre-set templates",
        "Little to no integration capabilities",
    ],
    gallabox: [
        "No added cost",
        "Dynamic, adaptable conversational flow",
        "High conversational intelligence",
        "No pesky “outage or over-limit” promise",
        "Generate custom real-time responses",
        "Sync easily with third-party apps",
    ],
};

const AiPage: React.FC = () => {
    return (
        <NewLayout
            title="Gallabox Gen AI: Harness the power of AI WhatsApp Chatbot | Gallabox"
            description="Access the limitless power of AI, right inside Gallabox. Respond faster, communicate effectively, and make an impact with WhatsApp AI Chatbot"
            canonical="https://gallabox.com/whatsapp-ai-chatbot"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ai/ai-og-revised.png" }}
        >
            <AiHeroSection botIconSrc="https://assets.gallabox.com/gb-home/ai/herosection-mp4.mp4" />

            <div className="lg:max-w-7xl mx-auto">
                <p className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</p>
                <ClientLogos />
            </div>

            <FeatureCardSection
                isImageRightSide
                imageURl="https://assets.gallabox.com/gb-home/ai/accelerate.png"
                title="Accelerate WhatsApp Sales Cycles with Personalisation"
                description="Keep pace with ever-changing customer demands and elevate your customer experience with personalised responses. Tap into the power of our AI-powered chatbot and guide users towards business goals like increased appointment bookings, improved engagement, and more."
            />

            <AiCompareComponent {...aiCompareData} />

            <CardDataCarousal
                title="Experience an AI-Powered Content Makeover"
                description="Empower your agents with AI rewrite, helping them generate and express their thoughts with the utmost effectiveness to convince and convert your customers."
                cardDataCollection={cardDataCollection}
            />

            <AIChatbotSection sections={sections} />

            <YellowCTAhref
                buttonText="Learn More"
                customText={<div className="text-2xl md:text-3xl font-bold text-yellow-800">Pocket-Friendly Pricing Plans Tailored for Every Budget</div>}
            />

            <AiChatbotSections
                titleText="Experience the Real Power of"
                desc="AI-Powered Chatbots"
                AiChatbotSectionsPropsData={[
                    {
                        img: "https://assets.gallabox.com/gb-home/ai/section1-updated.png",
                        title: "Personalized Travel Plans",
                        desc: " Make vacation planning easy for your customers with Gallabox's AI bot that finds affordable accommodations within budget and lists them by price, location,or any other parameter.",
                    },
                    {
                        img: "https://assets.gallabox.com/gb-home/ai/section2.png",
                        title: "Tailored Ed-Tech Experiences",
                        desc: " Answers student questions with our AI-powered chatbot which combs through pre-defined FAQs to gather information, collate them, analyze, and send customized responses.",
                    },
                    {
                        img: "https://assets.gallabox.com/gb-home/ai/section3-updated.png",
                        title: "Streamlined Shopping",
                        desc: "Improves shopping using advanced filters and knowledge base analysis. If a customer asks for 'cheap red sneakers,' the bot filters products by price and colour, showing all affordable red sneakers. This makes shopping efficient and personalized.",
                    },
                ]}
            />

            <ImageGrid />

            <YellowCTAhref
                buttonText="Get Started Today"
                customText={<div className="text-2xl md:text-3xl font-bold text-yellow-800">Ready to Bring AI Tools into Your WhatsApp Business Account?</div>}
            />
        </NewLayout>
    );
};

export default AiPage;
